<div [ngClass]="(crossReferencedContentID!='' && paraNum == crossReferencedContentID)?'cross-referenced-content-border mt_1':''" class="print-all-content">
  <div [ngClass]="rightOverLayPage==true?'cross-referenced-component':'component'" [id]="paraNum">
    <div [ngClass]="rightOverLayPage==true ?'':'topicBody'">

      <div role="navigation" [attr.aria-label]="id">
        <div class="ml-70 flex-display" *ngIf="(crossReferencedContentID!='' && paraNum == crossReferencedContentID)">
          <span><img src="../../../../assets/icons/cross-ref.svg" alt="Archive" class="cross-ref-image"></span><span class="font-14 mt-3px cross-ref-content">CROSS-REFERENCED CONTENT</span>
        </div>
        <div class="row">
          <div *ngIf="paraTitle[0] != null && paraTitle[0].headingName != ''" class="width-90 col-12">
            <div class="mb-1 ">
              <h4 class="right-overlay-heading">
                <span *ngIf="paraNum != ''">&#183;&nbsp;>&nbsp;<span [id]="paraTitle[0].headingId" [class.paragraphId]="paraNum == ''" [innerHTML]="paraTitle[0].headingName"></span></span>
                <span *ngIf="paraNum == ''" [id]="id" class="highlight-blue border-bottom-help cursor-pointer singleLine" [innerHTML]="paraTitle[0].headingName" (click)="redirectToGlossaryTermUsage($event)"></span>
              </h4>
            </div>
          </div>
          <div *ngIf="paraTitle[1] != null && paraTitle[1].headingName != ''" class="width-90">
            <div class="mb-1">
              <h5 class="right-overlay-heading-h5"><span>&#183;&nbsp;&#183;&nbsp;>&nbsp;</span><span [id]="paraTitle[1].headingId" [innerHTML]="paraTitle[1].headingName"></span></h5>
            </div>
          </div>
          <div *ngIf="paraTitle[2] != null && paraTitle[2].headingName != ''" class="width-90">
            <div class="mb-1">
              <h6 class="right-overlay-heading-h5"><span>&#183;&nbsp;&#183;&nbsp;&#183;&nbsp;>&nbsp;</span><span [id]="paraTitle[2].headingId" [innerHTML]="paraTitle[2].headingName"></span></h6>
            </div>
          </div>
          <div *ngIf="paraTitle[3] != null && paraTitle[3].headingName != ''" class="width-90">
            <div class="mb-1">
              <h6 class="right-overlay-heading-h5"><span>&#183;&nbsp;&#183;&nbsp;&#183;&nbsp;&#183;&nbsp;>&nbsp;</span><span [id]="paraTitle[3].headingId" [innerHTML]="paraTitle[3].headingName"></span></h6>
            </div>
          </div>
          <div *ngIf="paraTitle[4] != null && paraTitle[4].headingName != ''" class="width-90">
            <div class="mb-1">
              <h6 class="right-overlay-heading-h5"><span>&#183;&nbsp;&#183;&nbsp;&#183;&nbsp;&#183;&nbsp;&#183;&nbsp;>&nbsp;</span><span [id]="paraTitle[4].headingId" [innerHTML]="paraTitle[4].headingName"></span></h6>
            </div>
          </div>
          <div class="contentShow">
            <div class="flex-display width-91">
              <div class="flex-display width-100">
                <div class="paragraphId floatL" [ngClass]="paraNum!=null && paraNum!=''?'width-12':'width-2'">{{paraNum}}</div>
                <div role="region" [attr.aria-label]="paraArticleId" class="print-content width-90 floatR">
                  <article tabindex="0" role="article" (contextmenu)="onRightClick($event)" (mouseover)="mouseOverFunctions($event)" id="{{paraArticleId}}" class="dita-content" (click)="openLinkById($event)" [innerHTML]="dita" (keyup.enter)="openLinkById($event)"></article>
                </div>
              </div>
              <div class="highlight-blue print-content-hide width-2" *ngIf="actionLabel.length > 0 && (!archivePage)">
                <app-paragraph-action-menu [paraTitle]="paraTitle" [compname]="compname" [menuListItems]="actionLabel" [paragraphId]="id" [paraArticleId]="paraArticleId" [annotationCountString]="annotationCount" [bookmarkCountString]="bookmarkCount" [UserInfo]="UserInfo" [printqueueAdd]="printqueueAdd" [breadCrumbPath]="BreadcrumbPath" [parentComponent]="ParentComponent" [crumbData]="crumbData" [paraNum]="paraNum != ''? paraNum:paraTitle[0].headingName" [pageNums]="pageNums" [pageurl]="pageurl"></app-paragraph-action-menu>
              </div>
            </div>
          </div>
          <div class="printShow">
            <div class="containerP width-100 d-flex">
              <div class="pn col-2" style="float: left; width: 15%">{{paraNum}}</div>
              <div role="region" class="col-10" style="float: right; width:85%" tabindex="0" id="{{paraArticleId}}print" [innerHTML]="dita">
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="annotationContentBool && !annotationPrintContentBool && (!archivePage)">
          <app-annotation-records [paragraphId]="id" [lineBool]="lineRequired" [paraNum]="paraNum"></app-annotation-records>
        </div>
        <div *ngIf="annotationPrintContentBool && (!archivePage)">
          <app-annotation-records-print-prv [paragraphId]="id" [UserInfo]="UserInfo" [lineBool]="lineRequired"></app-annotation-records-print-prv>
        </div> 
      </div>
    </div>
  </div>
</div>
